import React from 'react';

export default function FormPut(props) {
  const {
    register,
    errors,
    name,
    label,
    required,
    placeholder,
    defaultValue,
    disabled,
    type,
  } = props;
  return (
    <>
      {label && (
        <label
          className="block uppercase tracking-wide  text-xs font-bold mb-2 text-gray-900"
          htmlFor={name}
        >
          {label}
          {required && <span className="text-red-500">*</span>}
        </label>
      )}

      <input
        type={type || 'text'}
        className="appearance-none block w-full text-xs  text-gray-900 border border-light-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
        {...register(`${name}`)}
        defaultValue={defaultValue}
        placeholder={placeholder || label}
        disabled={disabled}
      />
      <p className="inputValidation text-xs text-red-800">
        {errors[name]?.message}
      </p>
    </>
  );
}
